import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Input as AntInput,
  Modal,
  Row,
  Select,
  Spin,
  Typography,
} from 'antd';
import { SemiboldText } from '../../components/common/Text';
import {
  fetchCenterBasicProfile,
  addNetworkSpoc,
  updateNetworkSpoc,
  removeNetworkSpoc,
} from '../../services';
import { showError } from '../../utils';

const { Paragraph, Title } = Typography;
const { Option } = Select;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: column;
`;

// const Row = styled.div`
//   display: flex;
//   flex-direction: row;
// `;

// const Col = styled.div`
//   display: flex;
//   flex: 1;
//   flex-direction: column;
//   margin-right: 10px;
// `;

class NetworkSpocScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      centerSpocs: [],
      spocId: null,
      name: '',
      email: '',
      phone: '',
      type: '',
      sendWhatsApp: false,
      sendEmail: false,
      sendCC: false,
      sendSMS: false,
      sendCall: false,
      formEditing: false,
      commType: '',
      waCheck: true,
    };
    console.log({ props });

    this.centerId = props.centerId;
  }

  componentDidMount = () => {
    this.fetchSpocs();
  };

  fetchSpocs = () => {
    this.setState({ loading: true });
    fetchCenterBasicProfile(this.centerId)
      .then((res) => {
        const basicProfile = res;
        const { spocs } = basicProfile;
        if (spocs) {
          this.setState({
            centerSpocs: spocs,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  validations = () => {
    let result = true;
    const { phone, email, commType, type, name } = this.state;
    const regexPhone = /^[0-9]{10}$/;
    const regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*\.\w+$/;
    if (!name) {
      const data = {
        errorMessage: 'Please provide SPOC Name',
        message: 'serverError',
      };
      const err = new Error('Invalid response');
      err.data = data;
      showError(err);
      return false;
    }
    if(!phone && !email){
      const data = {
        errorMessage: 'Please provide a phone number or email id. Both cannot be empty',
        message: 'serverError',
      };
      const err = new Error('Invalid response');
      err.data = data;
      showError(err);
      return false;
    }
    if (phone && !regexPhone.test(phone)) {
      const data = {
        errorMessage: 'Please provide a valid phone number',
        message: 'serverError',
      };
      const err = new Error('Invalid response');
      err.data = data;
      showError(err);
      return false;
      // throw err;
    }
    if (email && !regexEmail.test(email)) {
      const data = {
        errorMessage: 'Please provide valid email address',
        message: 'serverError',
      };
      const err = new Error('Invalid response');
      err.data = data;
      showError(err);
      return false;

      // throw err;
    }
    if (!type) {
      const data = {
        errorMessage: 'Please provide SPOC type.',
        message: 'serverError',
      };
      const err = new Error('Invalid response');
      err.data = data;
      showError(err);
      return false;
    }
    if (!commType) {
      const data = {
        errorMessage: 'SPOC Communication Type cannot be missing',
        message: 'serverError',
      };
      const err = new Error('Invalid response');
      err.data = data;
      showError(err);
      return false;
    }
    return result;
  };

  submit = () => {
    const {
      spocId,
      name,
      email,
      phone,
      type,
      sendWhatsApp,
      sendEmail,
      sendCC,
      sendSMS,
      sendCall,
      commType,
    } = this.state;
    if (!this.validations()) {
      return;
    }
    this.setState({ loading: true });
    if (!spocId) {
      addNetworkSpoc({
        centerId: this.centerId,
        name,
        email,
        phone,
        type,
        sendWhatsApp,
        sendEmail,
        sendCC,
        sendSMS,
        sendCall,
        commType,
      })
        .then(() => {
          this.cancelEditing();
          this.fetchSpocs();
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    } else {
      updateNetworkSpoc({
        spocId,
        name,
        email,
        phone,
        type,
        sendWhatsApp,
        sendEmail,
        sendCC,
        sendSMS,
        sendCall,
        commType,
      })
        .then(() => {
          this.cancelEditing();
          this.fetchSpocs();
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    }
  };

  // deletePractice = doctorPracticeId => {
  //   deletePractice(this.doctorId, doctorPracticeId)
  //     .then(res => {
  //       message.success('Practice deleted successfully');
  //       this.fetchPractice();
  //     })
  //     .catch(err => {
  //       console.log({ err });
  //     });
  // };

  editSpoc = (ele) => {
    this.setState({
      formEditing: true,
      spocId: ele.spocId,
      name: ele.name || '',
      email: ele.email || '',
      phone: ele.phone || '',
      type: ele.type || '',
      sendWhatsApp: ele.sendWhatsApp === 1 ? true : false,
      sendEmail: ele.sendEmail === 1 ? true : false,
      sendCC: ele.sendCC === 1 ? true : false,
      sendSMS: ele.sendSMS === 1 ? true : false,
      sendCall: ele.sendCall === 1 ? true : false,
      commType: ele.commType || '',
    });
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      spocId: null,
      name: '',
      email: '',
      phone: '',
      type: '',
      sendWhatsApp: false,
      sendEmail: false,
      sendCC: false,
      sendSMS: false,
      sendCall: false,
      commType: '',
    });
  };

  onFromToDateChange = (date, dateString) => {
    console.log({ date, dateString });
    this.setState({
      fromDate: dateString[0],
      toDate: dateString[1],
    });
  };

  onPracticeActiveChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
    this.setState({
      doctorPracticeActive: e.target.checked,
    });
  };

  removeSpoc = (ele) => {
    Modal.confirm({
      title: 'Confirm Removal',
      content: `Are you sure you want to remove ${ele.name} as SPOC for this center?`,
      onOk: () => {
        this.setState({ formSaving: true });
        removeNetworkSpoc(ele.spocId)
          .then(() => {
            this.fetchSpocs();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.setState({ formSaving: false });
          });
      },
    });
  };

  getCommType = (commType) => {
    switch (commType) {
      case 'payment-confirmation':
        return 'Payment Confirmation';
      case 'appointment-confirmation':
        return 'Appointment Confirmation';
      case 'all':
        return 'All';
      default:
        return 'None';
    }
  };

  render() {
    const {
      loading,
      centerSpocs,
      name,
      email,
      phone,
      type,
      sendWhatsApp,
      sendEmail,
      sendCC,
      sendSMS,
      sendCall,
      commType,
    } = this.state;
    const renderSpoc = (ele, idx) => {
      return (
        <Col key={idx} span={24} xs={24} md={12}>
          <Card>
            <EduRowComponent>
              <Row type="flex" align="middle" justify="space-between">
                <Col>
                  <Row type="flex" align="middle" gutter={[16, 16]}>
                    <Col>
                      <Title level={4} style={{ margin: 0 }}>
                        {ele.name}
                      </Title>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    {ele.phone}
                  </Paragraph>
                </Col>
                <Col xs={12}>
                  <Paragraph style={{ margin: 0 }}>{ele.email}</Paragraph>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    {ele.type}
                  </Paragraph>
                </Col>
                <Col xs={12}>
                  <Paragraph style={{ margin: 0 }}>
                    {`Comm. Type: ${this.getCommType(ele.commType)}`}
                  </Paragraph>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    {ele.sendWhatsApp
                      ? 'Whatsapp enabled'
                      : 'Whatsapp disabled'}
                  </Paragraph>
                </Col>
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    {ele.sendEmail ? 'Email enabled' : 'Email disabled'}
                  </Paragraph>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    {ele.sendCC ? 'CC Email enabled' : 'CC Email disabled'}
                  </Paragraph>
                </Col>
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    {ele.sendSMS ? 'SMS enabled' : 'SMS disabled'}
                  </Paragraph>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={12}>
                  <Paragraph strong style={{ margin: 0 }}>
                    {ele.sendCall ? 'Call enabled' : 'Call disabled'}
                  </Paragraph>
                </Col>
              </Row>
            </EduRowComponent>
            <Row gutter={[24, 16]} style={{ marginTop: '10px' }}>
              <Col xs={24} md={12}>
                <Button block type="primary" onClick={() => this.editSpoc(ele)}>
                  Edit
                </Button>
              </Col>
              <Col xs={24} md={12}>
                <Button
                  block
                  type="danger"
                  onClick={() => this.removeSpoc(ele)}
                >
                  Remove SPOC
                </Button>
              </Col>
              {/* <Popconfirm
            department="Are you sure delete this?"
            onConfirm={() => this.deletePractice(edu.doctorPracticeId)}
            // onCancel={cancel}
            okText="Yes"
            cancelText="No">
            <Button type="danger">Delete</Button>
          </Popconfirm> */}
            </Row>
          </Card>
        </Col>
      );
    };
    const renderSpocForm = () => {
      return (
        <Card>
          <BodyContainer>
            <Row gutter={24}>
              <Col xs={24} md={12}>
                <LabelText>SPOC Name</LabelText>
                <AntInput
                  value={name}
                  placeholder="SPOC Name"
                  onChange={(e) => {
                    this.setState({
                      name: e.target.value,
                    });
                  }}
                />
              </Col>

              <Col xs={24} md={12}>
                <LabelText>SPOC Phone</LabelText>
                <AntInput
                  value={phone}
                  onChange={(e) => {
                    const reg = /^[6789]\d{9}$/;
                    if (reg.test(e.target.value)) {
                      this.setState({
                        waCheck: false,
                      });
                    } else {
                      this.setState({
                        waCheck: true,
                      });
                    }
                    this.setState({
                      phone: e.target.value,
                    });
                  }}
                  placeholder="SPOC Phone"
                />
              </Col>

              <Col xs={24} md={12}>
                <LabelText>SPOC Email</LabelText>
                <AntInput
                  value={email}
                  onChange={(e) => {
                    this.setState({
                      email: e.target.value,
                    });
                  }}
                  placeholder="SPOC Email"
                />
              </Col>

              <Col xs={24} md={12}>
                <LabelText>SPOC Type</LabelText>
                <Select
                  style={{ width: '100%' }}
                  value={type}
                  defaultValue="Bank Account"
                  onChange={(e) => this.setState({ type: e })}
                >
                  <Option value="Appointment Desk">Appointment Desk</Option>
                  <Option value="Appointment Co-ordinator">
                    Appointment Co-ordinator
                  </Option>
                  <Option value="Central Board">Central Board</Option>
                  <Option value="Billing Desk">Billing Desk</Option>
                  <Option value="Reception">Reception</Option>
                  <Option value="Account Department">Account Department</Option>
                  <Option value="Doctor (Owner)">Doctor (Owner)</Option>
                  <Option value="Marketing Executive">
                    Marketing Executive
                  </Option>
                  <Option value="Marketing Head">Marketing Head</Option>
                </Select>
              </Col>
              <Col xs={24} md={12}>
                <LabelText>Communication Type</LabelText>
                <Select
                  style={{ width: '100%' }}
                  value={commType}
                  defaultValue="all"
                  onChange={(e) => this.setState({ commType: e })}
                >
                  <Option value="payment-confirmation">
                    Payment Confirmation
                  </Option>
                  <Option value="appointment-confirmation">
                    Appointment Confirmation
                  </Option>
                  <Option value="all">All</Option>
                </Select>
              </Col>
              <Col xs={24}>
                <Checkbox
                  style={{ marginTop: 10, marginBottom: 10 }}
                  checked={sendWhatsApp}
                  disabled={this.state.waCheck}
                  onChange={(e) => {
                    this.setState({
                      sendWhatsApp: e.target.checked,
                    });
                  }}
                >
                  Send WhatsApp
                </Checkbox>
                <Checkbox
                  style={{ marginTop: 10, marginBottom: 10 }}
                  checked={sendEmail}
                  onChange={(e) => {
                    this.setState({
                      sendEmail: e.target.checked,
                    });
                  }}
                >
                  Send Email
                </Checkbox>
                <Checkbox
                  style={{ marginTop: 10, marginBottom: 10 }}
                  checked={sendCC}
                  onChange={(e) => {
                    this.setState({
                      sendCC: e.target.checked,
                    });
                  }}
                >
                  Send CC Email
                </Checkbox>
                <Checkbox
                  style={{ marginTop: 10, marginBottom: 10 }}
                  checked={sendSMS}
                  onChange={(e) => {
                    this.setState({
                      sendSMS: e.target.checked,
                    });
                  }}
                >
                  Send SMS
                </Checkbox>
                <Checkbox
                  style={{ marginTop: 10, marginBottom: 10 }}
                  checked={sendCall}
                  onChange={(e) => {
                    this.setState({
                      sendCall: e.target.checked,
                    });
                  }}
                >
                  Send Call
                </Checkbox>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col xs={24} md={12}>
                <Button
                  type="primary"
                  block
                  style={{ marginRight: 10 }}
                  onClick={this.submit}
                >
                  Submit
                </Button>
              </Col>
              <Col xs={24} md={12}>
                <Button block onClick={this.cancelEditing}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </BodyContainer>
        </Card>
      );
    };
    return (
      <Row type="flex" align="middle" gutter={[16, 16]}>
        <React.Fragment>
          <Col span={24}>
            <Title type={2}>Center SPOCs</Title>
          </Col>
          {loading ? (
            <div>
              <Spin />
            </div>
          ) : (
            <React.Fragment>
              <Col span={24}>{centerSpocs.map(renderSpoc)}</Col>
              {!this.state.formEditing ? (
                <Col span={24}>
                  <Button
                    style={{ alignSelf: 'center', flex: 0, padding: 4 }}
                    onClick={() => this.editSpoc({})}
                  >
                    Add SPOC
                  </Button>
                </Col>
              ) : (
                renderSpocForm()
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default withRouter(connect(mapStateToProps)(NetworkSpocScreen));
